/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Less_Candid_Boar_CookInputs */

const fr_less_candid_boar_cook = /** @type {(inputs: Less_Candid_Boar_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer mot de passe`)
};

/**

* @param {Less_Candid_Boar_CookInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const less_candid_boar_cook = /** @type {((inputs?: Less_Candid_Boar_CookInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Less_Candid_Boar_CookInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_less_candid_boar_cook(inputs)
});